//Random Number Generator
const randomNumber = (number) => {
  return Math.floor(Math.random() * (number + 1));
};

export {randomNumber}; 